export default __webpack_public_path__ + "static/media/MySQL-Logo.wine.3767cb7e.png";